module.exports = __webpack_public_path__ + "img/internship-challenge-template.6626bf77.png";